import { Box, Theme, Typography } from '@material-ui/core';
import { Assessment, CheckCircle, Assignment } from '@material-ui/icons';
import { createStyles, makeStyles } from '@material-ui/styles';
import React from 'react';
import { SessionReportVisibility } from './SessionReportVisibility';
import { PreventVolunteerReports } from './PreventVolunteerReports';
import { PreventVolunteerAddOthersInReports } from './PreventVolunteerAddOthersInReports';
import { LightTouchReports } from './LightTouchReports';
import { HideReportAttendance } from './HideReportAttendance';
import { PrefillReportAttendance } from './PrefillReportAttendance';
import { AllowCICO } from './AllowCICO';
import { AdHocReporting } from './AdHocReporting';
import { AllowVolunteerActivityCancellation } from './AllowVolunteerActivityCancellation';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      paddingLeft: 40,
      paddingRight: 40,
      paddingTop: 20,
      backgroundColor: '#F9F9F9',
      minHeight: 'calc(100% - 20px)',
    },
    contentContainer: {
      background: 'white',
      paddingTop: '1.25rem',
      paddingBottom: '1.25rem',
      paddingLeft: '1.875rem',
      paddingRight: '1.875rem',
      marginTop: '2.25rem',
    },
    heading: {
      alignItems: 'center',
      paddingBottom: '8px',
      borderBottom: '1px solid #efefef',
    },
    headingTitle: {
      color: theme.color.grey.neutralBrand900,
      fontWeight: 600,
      paddingBottom: '5px',
      fontSize: 20,
    },
    sectionTitle: {
      fontWeight: 600,
      fontSize: '16px',
      display: 'flex',
      alignItems: 'center',
    },
    sectionDescription: {
      fontSize: '14px',
      color: '#808080',
      marginTop: '0.25rem',
      marginBottom: '1.5rem',
    },
  })
);

const AdminConsoleActivityReportingPanel = () => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Box className={classes.heading}>
        <Typography variant='h2' className={classes.headingTitle}>
          Activity Reporting
        </Typography>
        <Typography variant={'body2'}>
          {'Manage settings relating to activity reporting and check-in/check-out'}
        </Typography>
      </Box>
      <Box className={classes.contentContainer}>
        <Typography className={classes.sectionTitle}>
          <Assessment style={{ fontSize: '14px', paddingRight: '5px' }} />
          Session Reporting
        </Typography>
        <Typography variant={'body2'} className={classes.sectionDescription}>
          Configure visibility and access settings for session reports
        </Typography>
        <SessionReportVisibility />
        <PreventVolunteerReports />
        <PreventVolunteerAddOthersInReports />
        <LightTouchReports />
        <HideReportAttendance />
        <PrefillReportAttendance />
        <AllowVolunteerActivityCancellation />
      </Box>
      <Box className={classes.contentContainer}>
        <Typography className={classes.sectionTitle}>
          <CheckCircle style={{ fontSize: '14px', paddingRight: '5px' }} />
          Check In & Check Out
        </Typography>
        <Typography variant={'body2'} className={classes.sectionDescription}>
          Manage volunteer check-in and check-out functionality for sessions
        </Typography>
        <AllowCICO />
        {/* <AllowMultipleCICO /> */}
      </Box>
      <Box className={classes.contentContainer}>
        <Typography className={classes.sectionTitle}>
          <Assignment style={{ fontSize: '14px', paddingRight: '5px' }} />
          Ad-Hoc Reporting
        </Typography>
        <Typography variant={'body2'} className={classes.sectionDescription}>
          Configure ad-hoc reporting permissions for volunteers to submit reports outside scheduled sessions
        </Typography>
        <AdHocReporting />
      </Box>
    </Box>
  );
};

export { AdminConsoleActivityReportingPanel };
